import { getLocalizedValueFromMultiLangValues } from './getLocalizedValueFromMultiLangValues';

function parseTimeToMinutes(timeStr: string): number {
  if (!timeStr) return -1;
  const [time, period] = timeStr.split(' ');
  if (!time || !period) return -1;

  const [hourStr, minuteStr] = time.split(':');
  let hour = parseInt(hourStr, 10);
  const minute = parseInt(minuteStr, 10);

  if (period.toUpperCase() === 'PM' && hour !== 12) hour += 12;
  if (period.toUpperCase() === 'AM' && hour === 12) hour = 0;

  return hour * 60 + minute;
}

export type SortableKeys = 'title' | 'updatedAt' | 'createdAt' | 'time';

export function sortItems<T extends Record<string, any>>(
  items: T[],
  sortBy: SortableKeys,
  ascending = true
): T[] {
  return [...items].sort((a, b) => {
    let valA: string | number = '';
    let valB: string | number = '';

    switch (sortBy) {
      case 'title':
        valA =
          getLocalizedValueFromMultiLangValues(a.title)?.toLowerCase() || '';
        valB =
          getLocalizedValueFromMultiLangValues(b.title)?.toLowerCase() || '';
        break;

      case 'updatedAt':
        valA = a.updatedAt ? new Date(a.updatedAt).getTime() : 0;
        valB = b.updatedAt ? new Date(b.updatedAt).getTime() : 0;
        break;

      case 'createdAt':
        valA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
        valB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
        break;

      case 'time':
        valA = parseTimeToMinutes(a.time);
        valB = parseTimeToMinutes(b.time);
        break;
    }

    if (valA < valB) return ascending ? -1 : 1;
    if (valA > valB) return ascending ? 1 : -1;
    return 0;
  });
}
